module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTDw2NTs2NTs3MTk5MTw2NTw2NTw3ND86Lzs1Mzw2NT02NT03NiPwkyQAAAAMdFJOUwDvgCAZlN9OEEC/Y8QVrFIAAADgSURBVDjLY2AYtCDnDAo4BhPnPIMGJkAlWE+jGqCzAMqwOYwq0XMCytgTgCrBdQhm9wRUCc6DUPoYuitlJmC1G247ut1w29HthtsOspstgQGJgNp6Boh5DqAQZ/BLyBhAHQAnmCEe0TmDAY5C/NFw5oxQ4BkkgkOBAW4JCjjDQAsJJpkzZw4GgGgQiSQRA3LkITB9CEUC5EmQt2QMQCSSxBkEfYbWEjgt1wGHLBYJVpmDClglUINEpgFVggPGWKOAKsF9CsqYc7oBWYJDB5Y0mdCjXAFm2S4U4YMrB2+hAABQFrF6MM0MKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/store.png
// module id = 1807
// module chunks = 0